import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
// import MKInput from "components/MKInput";
// import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Image
import bgImage from "assets/images/placeholders/placeholder.jpg";
import MKFileUploadButton from "components/MKFileUploadButton";
import { MenuItem, Select, InputLabel } from "@mui/material";

function UploadPage() {
  const [files, setFiles] = useState(null);

  console.log(files, "files", files && URL.createObjectURL(files?.[0]));

  const uploadImage = (event) => {
    if (event?.target?.files) {
      setFiles(event?.target?.files);
    }
  };

  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar
          routes={routes.filter((item) => item.show === true)}
          action={{
            type: "internal",
            route: "/pages/authentication/sign-in",
            label: "Sign In",
            color: "info",
          }}
        />
      </MKBox>
      <Grid container ml={{ xs: 0, lg: 3 }} mt={6} spacing={3} alignItems="center">
        <Grid item xs={12} md={files ? 11 : 6} lg={files ? 11 : 6}>
          <MKBox
            display={"flex"}
            width="calc(100% - 3rem)"
            height={{ xs: "calc(40vh - 2rem)", md: "calc(80vh - 2rem)", lg: "calc(80vh - 2rem)" }}
            borderRadius="lg"
            ml={{ xs: 0, lg: 2 }}
            mt={{ xs: 0, lg: 2 }}
            sx={{
              backgroundImage: `url(${files?.[0] ? URL.createObjectURL(files?.[0]) : bgImage})`,
              // backgroundImage: `url(${bgImage})`,
              backgroundRepeat: "no-repeat",
              border: "2px dashed #cdcdcd",
              backgroundPosition: "center",
              backgroundColor: "white !important",
            }}
          />
        </Grid>
        <Grid
          item
          xs={files ? 12 : 12}
          md={files ? 11 : 5}
          lg={files ? 11 : 5}
          ml={{ xs: "auto", md: 2, lg: 0 }}
          mr={{ xs: "auto", md: 2, lg: 0 }}
        >
          <MKBox
            bgColor="white"
            borderRadius="xl"
            shadow="lg"
            display={"flex"}
            flexDirection="column"
            width="calc(100% - 3rem)"
            justifyContent={{ lg: "center", xs: "top" }}
            mt={{ xs: 5, sm: 18, md: 20 }}
            mb={{ xs: 5, sm: 18, md: 20 }}
            mx={{ lg: 3 }}
          >
            <MKBox
              variant="gradient"
              bgColor="info"
              coloredShadow="info"
              display={files ? "none" : "block"}
              borderRadius="lg"
              p={2}
              mx={{ lg: 2 }}
              mt={{ lg: -3 }}
            >
              <MKTypography variant="h3" color="white">
                Virtual Staging
              </MKTypography>
            </MKBox>
            <MKBox p={3} display={files ? "none" : "block"}>
              <MKTypography variant="h6" color="black">
                Upload Image Or Drop Image Here
              </MKTypography>
              <MKFileUploadButton color={"white !important"} onChange={uploadImage} />
            </MKBox>
            <MKBox p={3} display={files ? "block" : "none"}>
              <MKTypography variant="h6" color="black">
                Choose Filter
              </MKTypography>
              <InputLabel id="demo-simple-select-label">Theme</InputLabel>
              <Select>
                <MenuItem value={"Astheic"}>Asthetic</MenuItem>
                <MenuItem value={"Astheic"}>Asthetic</MenuItem>
                <MenuItem value={"Astheic"}>Asthetic</MenuItem>
              </Select>
            </MKBox>
          </MKBox>
        </Grid>
      </Grid>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default UploadPage;
